enum AuthRequestType {
    LOGIN = "LOGIN",
    ACTION_CONFIRMATION = "ACTION_CONFIRMATION"
}

export default AuthRequestType;